export const createChatId = (uid1: string, uid2: string) => {
  return uid1 < uid2 ? uid1 + uid2 : uid2 + uid1;
};

export const explodeMembersFromChatId = (chatId: string) => {
  const partLength = chatId.length / 2;
  return [chatId.substr(0, partLength), chatId.substr(-partLength)];
};
